import { IonIcon } from '@ionic/react'
import { swapVerticalOutline } from 'ionicons/icons'
import { useQueryParam, withDefault, StringParam } from 'use-query-params'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent, useDrawer } from '~/shared/ui/Drawer'
import { IonCheckbox as Checkbox } from '~/shared/ui/form/Checkbox'
import { SCROLLABLE_LIST_SORT_KEY } from '~/shared/ui/ScrollableList'
import { myPalette } from '~/shared/ui/theme'
import { DrawerWrapper, Title } from './styled'

type Option = { key: string; label: string }

type SortProps = {
  options: Option[]
}

export function Sort({ options }: SortProps) {
  const [isShow, openDrawer, closeDrawer] = useDrawer()

  const [sortQuery, setSortQuery] = useQueryParam(
    SCROLLABLE_LIST_SORT_KEY,
    withDefault(StringParam, ''),
  )

  const handleOnChange = (option: Option) => {
    closeDrawer()
    setSortQuery(option.key, 'replaceIn')
  }

  return (
    <div>
      <Button
        fullWidth
        startDecorator={
          <IonIcon
            icon={swapVerticalOutline}
            style={{ margin: 0, width: '20px', height: '20px' }}
          />
        }
        variant='textLink'
        onClick={openDrawer}
        contentProps={{ style: { padding: '0' } }}
        style={{ color: myPalette.black.main, fontSize: '14px' }}
      >
        Сортировка
      </Button>
      <DrawerComponent isShow={isShow} onCancel={closeDrawer}>
        <DrawerWrapper>
          <Title>Сортировка</Title>

          {options.map((option) => (
            <Checkbox
              onClick={() => handleOnChange(option)}
              key={option.key}
              labelPlacement='end'
              justify='start'
              checked={option?.key === sortQuery}
            >
              {option.label}
            </Checkbox>
          ))}
        </DrawerWrapper>
      </DrawerComponent>
    </div>
  )
}
